module.exports = __webpack_public_path__ + "static/media/iconTransport.bffe359e.svg";